
<ion-grid *ngIf="currentDrug">
  <ion-row>
    <ion-col>
      <div class="c3-flex-column">
        <ion-label>
          <strong>{{ currentDrug?.name }}</strong>
        </ion-label>
        <ion-note>
          <small>{{ currentDrug?.active_ingredient }}</small>
          <small>, </small>
          <small>{{ currentDrug?.form }} - {{ currentDrug?.box }}</small>
          <small>, </small>
          <small>Codice: {{ currentDrug?._id }}</small>
        </ion-note>
      </div>
    </ion-col>

    <ion-col size="auto">
      <ion-buttons *ngIf="!disabled">
        <ion-button color="secondary" (click)="onDrugSelected(null)">
          <ion-icon class="ion-hide-md-up" [src]="'find-replace' | getIcon"></ion-icon>
          <span class="ion-hide-md-down">Cambia Farmaco</span>
        </ion-button>
      </ion-buttons>
    </ion-col>
  </ion-row>
</ion-grid>


<ng-container *ngIf="!currentDrug">
  <ion-item>
    <ion-label position="stacked">Farmaco</ion-label>
    <ion-input
      #inputField
      type="text"
      [c3Autocomplete]="autocomplete"
      required
      placeholder="Cerca farmaco (minimo 3 caratteri)"
      [ngModel]="drugSearchValue"
      (ngModelChange)="onDoSearch($event)"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="disabled"
    >
    </ion-input>

    <ion-spinner slot="end" color="secondary" *ngIf="searchPending"></ion-spinner>
  </ion-item>

  <c3-autocomplete #autocomplete="c3Autocomplete">
    <ng-template c3AutocompleteContent>
      <ion-list>
        <ion-list-header *ngIf="searchResults?.length === 0">
          <ion-label>Nessun risultato</ion-label>
        </ion-list-header>
        <c3-option *ngFor="let drug of searchResults" [value]="drug">
          <ion-item button>
            <div class="c3-flex-column ion-margin-top ion-margin-bottom">
              <ion-label>
                <strong>{{ drug.name }}</strong>
              </ion-label>
              <ion-note>
                <small>{{ drug.active_ingredient }}</small>
              </ion-note>
              <ion-note>
                <small>{{ drug.form }} - {{ drug.box }}</small>
              </ion-note>
              <ion-note>
                <small>Codice: {{ drug._id }}</small>
              </ion-note>
            </div>
          </ion-item>
        </c3-option>
      </ion-list>
    </ng-template>
  </c3-autocomplete>
</ng-container>
